// let subDomain = 'https://test-post.jaketdistromedan.com/'
let subDomain = 'https://posbackend.jdmstore.id/'
// let subDomain = 'http://localhost:8000/'
// let subDomain = URLparts[0].indexOf('localhost') === -1 ? URLparts[0] : 'cemaraasri'
let Init = () => {
  return {
    subDomain: subDomain
  }
}
export default new Init()



// WEBPACK FOOTER //
// ./src/config/init.js